let cfg = null;
const loaded = {};

function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); } // eslint-disable-line

function addScript(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export const getConsent = () => { try { return JSON.parse(localStorage.getItem("tt_consent")); } catch { return null; } };

export function applyConsent(c) {
  localStorage.setItem("tt_consent", JSON.stringify(c));
  const g = (v) => (v ? "granted" : "denied");
  gtag("consent", "update", { analytics_storage: g(c.analytics), ad_storage: g(c.marketing), ad_user_data: g(c.marketing), ad_personalization: g(c.marketing) });
  if (!cfg) return;
  if (c.analytics && cfg.gtm_id && !loaded.gtm) {
    loaded.gtm = true;
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    addScript(`https://www.googletagmanager.com/gtm.js?id=${cfg.gtm_id}`);
  }
  if (c.analytics && cfg.ga4_id && !loaded.ga4) {
    loaded.ga4 = true;
    addScript(`https://www.googletagmanager.com/gtag/js?id=${cfg.ga4_id}`);
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", cfg.ga4_id);
  }
  if (c.marketing && cfg.meta_pixel_id && !loaded.fb) {
    loaded.fb = true;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", cfg.meta_pixel_id);
    window.fbq("track", "PageView");
  }
}

export function initTracking(tracking) {
  cfg = tracking || {};
  const c = getConsent();
  if (c) applyConsent(c);
}

const FB = { sign_up: "CompleteRegistration", purchase: "Purchase", begin_checkout: "InitiateCheckout", bookie_click: "Lead", telegram_connect: "Contact" };

export function track(event, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (loaded.ga4) gtag("event", event, params);
  if (loaded.fb && window.fbq) window.fbq("track", FB[event] || event, params.value ? { value: params.value, currency: params.currency || "EUR" } : params);
}
